import * as React from "react";
import { SVGProps, memo } from "react";
const SvgSpacesMediumTable = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <path
      d="M2.1 7v1H8v3H2.1v1H8v3H2.1v1H8v3.1h1V16h5v3.1h1V16h6.8v-1H15v-3h6.8v-1H15V8h6.8V7H2.1zM9 11V8h5v3H9zm0 4v-3h5v3H9z"
      style={{
        fill: "#b3b3b5",
      }}
    />
    <path
      d="M21 4v15H3V4h18m0-1H3c-.6 0-1 .4-1 1v15c0 .6.4 1 1 1h18c.6 0 1-.4 1-1V4c0-.6-.5-1-1-1z"
      style={{
        fill: "#6e6f72",
      }}
    />
  </svg>
);
const Memo = memo(SvgSpacesMediumTable);
export default Memo;
